
export default {
  '/groups/:id': {
    tag: 'page-groups-single',
  },
  '/modals': {
    tag: 'page-modals',
  },
  '/': {
    tag: 'page-index',
    // ssr: false,
  },
  '/settings': {
    tag: 'page-index',
    // ssr: false,
  },
  '/children/:id/works': {
    tag: 'page-children-works',
  },
  '/children/:child_id/works/:work_id': {
    tag: 'page-works-single',
  },
  '/children/:id/bank/:type': {
    tag: 'page-bank-edit',
  },
  '/children/:id/loan': {
    tag: 'page-loan',
  },
  '/children/:id/user': {
    tag: 'page-user',
  },

  // debug
  '/debug': {
    tag: 'page-debug',
  },
  '/debug/redirect': {
    tag: 'page-debug-redirect',
  },
  // URL は変えずタグだけリダイレクトさせる
  '/debug/tagredirect': {
    tag: async ({req, res}) => {
      // ここで db の存在チェックとかしてなければ 404 に飛ばす
      res.status(404);
      return 'page-error';
    },
  },

};

